export default function () {
  if (document.getElementById('offer-contact-app')) {
    import(/* webpackChunkName: "offer-contact-form" */ '../_03_organisms/offer/contact/main');
  }

  if (document.querySelector('.btn-extendable-container')
    || document.querySelector('.contact-congratulations-activate .resend-activation-email')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "offer-contact-form" */ '../_03_organisms/offer/contact-form');
  }
}
